<div
  #infoBox
  [ngClass]="from === 'project-detail' ? 'd-flex align-items-center' : ''"
>
  <div
    class="me-2"
    title="View Latest Audit Details"
    *ngIf="showAuditButton"
  >
    <img
      class="cursor-pointer"
      src="./assets/icons/info.svg"
      alt="Menu"
      width="24px"
      height="24px"
      (click)="toggleShowAudit()"
    />
  </div>
  <div
    [ngClass]="
      from === 'project-detail' ? 'info-box-secondary ' : 'info-box mb-3'
    "
    *ngIf="(from === 'project-detail' && isAuditShow) || from === ''"
  >
    <div class="container">
      <div class="mr-1rem">
        <p>Created By: {{ audit.createdBy || "--" }}</p>
        <p>Last Updated By: {{ audit.updatedBy || "--" }}</p>
      </div>
      <div class="m-auto">
        <p>Created On: {{ this.fnGetDate(audit.createdAt) || "--" }}</p>
        <p>Last Updated On : {{ this.fnGetDate(audit.updatedAt) || "--" }}</p>
      </div>
    </div>
  </div>
</div>
